export default __webpack_public_path__ + "static/media/onboarding_guide_4.d89aeba5.png";